import { useState, useMemo } from 'react'
import type { Payment } from '../types/payment.types'
import { mockPayments } from '../data/mockPayments'

export const usePayments = () => {
    const [payments] = useState<Payment[]>(mockPayments)
    const [searchText, setSearchText] = useState('')

    const filteredPayments = useMemo(() => {
        if (!searchText) return payments
        const lowerSearch = searchText.toLowerCase()
        return payments.filter(p => 
            p.id.toLowerCase().includes(lowerSearch) ||
            p.customer.toLowerCase().includes(lowerSearch) ||
            p.transactionId.toLowerCase().includes(lowerSearch) ||
            p.merchant.toLowerCase().includes(lowerSearch)
        )
    }, [payments, searchText])

    return {
        payments: filteredPayments,
        searchText,
        setSearchText
    }
}
